import { QuotingRole } from "./QuotingRole";

export class QuotingAdminUserType {
  public readonly key = 'QuotingAdminUserType';
  public readonly quotingRole = QuotingRole.Admin;
}
